import { Component } from '@angular/core';

@Component({
  selector: 'app-convert-word-to-png',
  imports: [],
  templateUrl: './convert-word-to-png.component.html',
  styleUrl: './convert-word-to-png.component.css'
})
export class ConvertWordToPngComponent {

}
